import { type Theme } from '../../types/Theme';

export const defaultTheme: Theme = 'standard';
